export default __webpack_public_path__ + "static/media/Reject.7edbc262.svg";